/**
 * auth-token-login-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * TODO
 */
export class AuthTokenLoginRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_AUTH_TOKEN_LOGIN;
	public static tag : MessageTag = MessageTag.REQ_AUTH_TOKEN_LOGIN;

  /**
   * Create a {@link AuthTokenLoginRequest}
   * @param  {string} token [description]
   */
  constructor (public token : string)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/auth-token-login-request.ts